/* Product page extras: gallery dots, hold-to-zoom, complete-the-look switches. Loaded on product pages only. */
(function(){
  /* phones: tuck the header search row away once the page is scrolled (hysteresis so it never flickers) */
  var hid=false;
  addEventListener('scroll',function(){var y=scrollY;if(!hid&&y>220){hid=true;document.documentElement.classList.add('pm-scrolled');}else if(hid&&y<60){hid=false;document.documentElement.classList.remove('pm-scrolled');}},{passive:true});

  function cartChanged(open){
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      try{FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,{cart:cart});}catch(x){}
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:!!open}}));
    });
  }

  function gallery(viewer){
    var sw=viewer.swiper;if(!sw)return false;
    var n=viewer.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    /* "1 / 8" counter on the photo instead of a row of tiny dots */
    if(n>1&&!viewer.parentElement.querySelector('.pm-pcount')){
      var d=document.createElement('span');d.className='pm-pcount';d.setAttribute('aria-hidden','true');
      viewer.parentElement.appendChild(d);
      var set=function(){d.textContent=(sw.realIndex+1)+' / '+n;};
      sw.on('slideChange',set);set();
    }
    /* first visit: the gallery nudges left and springs back once so people see it swipes */
    var seen=false;try{seen=sessionStorage.getItem('pmNudge');sessionStorage.setItem('pmNudge','1');}catch(x){}
    if(n>1&&!seen&&!matchMedia('(prefers-reduced-motion: reduce)').matches)setTimeout(function(){var t0=sw.translate;sw.setTransition(420);sw.setTranslate(t0-70);setTimeout(function(){sw.setTransition(520);sw.setTranslate(t0);},460);},1100);
    zoom(viewer,sw);fabric(viewer);return true;
  }

  /* first product a shopper opens: a magnifier glides over the fabric of the first photo once, with a hint, then fades.
     full-res photo at 3x, so the knit/print is visible. any touch stops it. never again after that (per browser) */
  function fabric(viewer){
    var seen=false;try{seen=localStorage.getItem('pmFab2');localStorage.setItem('pmFab2','1');}catch(x){seen=true;}
    if(seen||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var slide=viewer.querySelector('.swiper-slide-active')||viewer.querySelector('.swiper-slide'),img=slide&&slide.querySelector('img');
    if(!img||!slide.dataset.src)return;
    var hi=new Image(),stop=false,wrap=viewer.parentElement;
    hi.src=(slide.dataset.src.indexOf('//')===0?'https:':'')+slide.dataset.src;
    viewer.addEventListener('pointerdown',function(){stop=true;},{once:true});
    setTimeout(function(){hi.decode().then(run).catch(function(){});},1900);
    function run(){
      if(stop)return;
      var w=wrap.getBoundingClientRect(),r=img.getBoundingClientRect(),nr=img.naturalWidth/img.naturalHeight||0.75;
      /* the photo may be letterboxed (object-fit: contain): work out the drawn picture */
      var dw=r.width,dh=r.height;if(dw/dh>nr)dw=dh*nr;else dh=dw/nr;
      var ox=r.left-w.left+(r.width-dw)/2,oy=r.top-w.top+(r.height-dh)/2,Z=3,L=Math.round(Math.min(150,dw*.42));
      var lens=document.createElement('span');lens.className='pm-lens';lens.style.cssText='width:'+L+'px;height:'+L+'px;background-image:url("'+hi.src+'");background-size:'+dw*Z+'px '+dh*Z+'px';
      var tip=document.createElement('span');tip.className='pm-lens__tip';tip.textContent='hold the photo to see the fabric';
      wrap.appendChild(lens);wrap.appendChild(tip);
      var a={x:.42,y:.36},b={x:.58,y:.56},T=2600,t0=performance.now();
      function at(f){var x=a.x+(b.x-a.x)*f,y=a.y+(b.y-a.y)*f,cx=ox+x*dw,cy=oy+y*dh;
        lens.style.transform='translate('+(cx-L/2)+'px,'+(cy-L/2)+'px)';lens.style.backgroundPosition=(-(x*dw*Z-L/2))+'px '+(-(y*dh*Z-L/2))+'px';
        tip.style.transform='translate('+(cx-tip.offsetWidth/2)+'px,'+(cy+L/2+8)+'px)';}
      function end(){lens.classList.remove('on');tip.classList.remove('on');setTimeout(function(){lens.remove();tip.remove();},400);}
      at(0);requestAnimationFrame(function(){lens.classList.add('on');tip.classList.add('on');});
      (function step(now){if(stop)return end();var f=Math.min(1,(now-t0)/T);f=f<.5?2*f*f:1-Math.pow(-2*f+2,2)/2;at(f);
        if(now-t0<T)requestAnimationFrame(step);else setTimeout(end,900);})(t0);
    }
  }

  /* hold a photo to zoom into it under the finger, drag to look around, let go to spring back */
  function zoom(viewer,sw){
    var t=null,on=false,img=null,x0=0,y0=0,eat=false;
    function origin(x,y){var r=img.getBoundingClientRect();img.style.transformOrigin=Math.max(0,Math.min(100,(x-r.left)/r.width*100))+'% '+Math.max(0,Math.min(100,(y-r.top)/r.height*100))+'%';}
    function start(e){
      if(e.button>0)return;x0=e.clientX;y0=e.clientY;
      img=(viewer.querySelector('.swiper-slide-active')||viewer).querySelector('img');if(!img)return;
      clearTimeout(t);t=setTimeout(function(){
        on=true;eat=true;sw.allowTouchMove=false;origin(x0,y0);
        var sl=img.closest('[data-src]');if(sl&&!img.dataset.hi){img.dataset.hi='1';var hi=new Image();hi.onload=function(){img.removeAttribute('srcset');img.src=hi.src;};hi.src=(sl.dataset.src.indexOf('//')===0?'https:':'')+sl.dataset.src;}
        img.classList.add('pm-zoomed');
        if(navigator.vibrate)try{navigator.vibrate(8);}catch(x){}
      },420);
    }
    function move(e){
      if(on){origin(e.clientX,e.clientY);return;}
      if(t&&Math.abs(e.clientX-x0)+Math.abs(e.clientY-y0)>10){clearTimeout(t);t=null;}
    }
    function end(){clearTimeout(t);t=null;if(!on)return;on=false;img.classList.remove('pm-zoomed');sw.allowTouchMove=true;}
    viewer.addEventListener('pointerdown',start);
    viewer.addEventListener('pointermove',move);
    ['pointerup','pointercancel','pointerleave'].forEach(function(k){viewer.addEventListener(k,end);});
    /* while zoomed the finger pans the photo, not the page */
    viewer.addEventListener('touchmove',function(e){if(on&&e.cancelable){e.preventDefault();var p=e.touches[0];origin(p.clientX,p.clientY);}},{passive:false});
    viewer.addEventListener('touchend',end);
    viewer.addEventListener('contextmenu',function(e){if(on||t)e.preventDefault();});
    /* the release after a zoom must not open the lightbox */
    viewer.addEventListener('click',function(e){
      if(eat){eat=false;e.preventDefault();e.stopPropagation();return;}
      /* a plain tap opens the full-screen viewer (pinch to see the fabric) */
      if(e.target.closest('.product__media-zoom,button,a'))return;
      var z=e.target.closest('.swiper-slide');z=z&&z.querySelector('.product__media-zoom');if(z){e.preventDefault();z.click();}
    },true);
  }

  function initGallery(){
    var v=document.querySelector('.section-main-product .product__media-gallery-viewer');if(!v)return;
    var k=0;(function wait(){if(!gallery(v)&&k++<40)setTimeout(wait,150);})();
  }

  /* complete the look: switch on = add that piece now, switch off = take it out again */
  function sizesPicked(){
    return [].map.call(document.querySelectorAll('.section-main-product variant-selects input[type=radio]:checked'),function(i){return i.value.toLowerCase().replace(/\s/g,'');});
  }
  function matchSize(box){
    [].forEach.call(box.querySelectorAll('[data-ctl-item]'),function(it){
      var want=sizesPicked(),all=it.dataset.all||'';
      /* made in the picked size but sold out in it: hide (a piece already switched on stays) */
      var made=want.some(function(w){return all.indexOf('|'+w+'|')>=0;});
      var sel=it.querySelector('select');
      var avail=sel?[].some.call(sel.options,function(o){return want.indexOf(o.dataset.size)>=0;}):true;
      it.hidden=!it.dataset.key&&made&&!avail;
      if(it.dataset.key||!sel)return;
      [].some.call(sel.options,function(o){if(want.indexOf(o.dataset.size)>=0){sel.value=o.value;return true;}});
    });
    box.hidden=![].some.call(box.querySelectorAll('[data-ctl-item]'),function(it){return !it.hidden;});
  }
  function ctl(box){
    matchSize(box);
    document.addEventListener('change',function(e){if(e.target.closest&&e.target.closest('.section-main-product variant-selects'))setTimeout(function(){matchSize(box);},50);});
    function put(it,want){
      var b=it.querySelector('.pm-ctl__sw'),id=it.querySelector('[data-ctl-id]').value;
      it.classList.add('busy');
      var go=want
        ?fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:+id,quantity:1})}).then(function(r){if(!r.ok)throw r;return r.json();}).then(function(line){it.dataset.key=line.key;})
        :fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:it.dataset.key,quantity:0})}).then(function(){delete it.dataset.key;});
      return go.then(function(){b.setAttribute('aria-checked',want?'true':'false');return cartChanged(false);})
        .catch(function(){b.setAttribute('aria-checked',it.dataset.key?'true':'false');it.classList.add('err');setTimeout(function(){it.classList.remove('err');},1200);})
        .finally(function(){it.classList.remove('busy');});
    }
    box.addEventListener('click',function(e){var b=e.target.closest('.pm-ctl__sw');if(!b)return;var it=b.closest('[data-ctl-item]');if(it.classList.contains('busy'))return;put(it,b.getAttribute('aria-checked')!=='true');});
    /* a different size while switched on: swap the line in the cart */
    box.addEventListener('change',function(e){var it=e.target.closest('[data-ctl-item]');if(!it||!it.dataset.key||it.classList.contains('busy'))return;put(it,false).then(function(){return put(it,true);});});
  }

  /* the main add-to-cart button carries the picked size's price */
  document.addEventListener('variant:change',function(e){var v=e.detail&&e.detail.variant;if(!v||typeof v.price!=='number')return;
    document.querySelectorAll('[data-pm-price]').forEach(function(x){x.textContent=(v.price/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})+' EGP';});
    var off=v.compare_at_price>v.price?v.compare_at_price-v.price:0;
    document.querySelectorAll('[data-pm-save]').forEach(function(x){x.hidden=!off;if(off)x.querySelector('b').textContent=(off/100).toLocaleString('en-US',{maximumFractionDigits:2})+' EGP';});});

  function init(){initGallery();var c=document.querySelector('[data-ctl]');if(c)ctl(c);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
